import React from 'react';
import { NumericFormat } from 'react-number-format';

type Props = {
  t: (k: string) => string;
  subtotal: number;

  discountRateValue: number;
  discountAmountValue: number;

  onDiscountRateChange: (rate: number) => void;
  onDiscountAmountChange: (amt: number) => void;

  vatRateDisplay: string;
  vatTotal: number;
  netTotal: number;
};

const fmt = (n: number) =>
  new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n || 0));

export const DocTotalsPanel: React.FC<Props> = ({
  t,
  subtotal,
  discountRateValue,
  discountAmountValue,
  onDiscountRateChange,
  onDiscountAmountChange,
  vatRateDisplay,
  vatTotal,
  netTotal
}) => {


  return (
    <div className='d-flex justify-content-start'>
      <div className='border rounded-0 p-3 bg-body' style={{ width: 380, maxWidth: '100%' }}>
        <div className='mb-2'>
          <label className='form-label mb-1 fw-bold'>{t('الإجمالي')}</label>
          <input className='form-control form-control-sm bg-inverse bg-opacity-10' readOnly value={fmt(subtotal)} />
        </div>

        <div className='row g-2 mb-2'>
          <div className='col-6'>
            <label className='form-label mb-1'>{t('نسبة الخصم %')}</label>
            <NumericFormat
              value={discountRateValue}
              thousandSeparator=','
              decimalSeparator='.'
              decimalScale={2}
              allowNegative={false}
              className='form-control form-control-sm border-theme bg-body'
              onValueChange={v => onDiscountRateChange(v.floatValue ?? 0)}
            />
          </div>

          <div className='col-6'>
            <label className='form-label mb-1'>{t('الخصم')}</label>
            <NumericFormat
              value={discountAmountValue}
              thousandSeparator=','
              decimalSeparator='.'
              decimalScale={2}
              allowNegative={false}
              className='form-control form-control-sm border-theme bg-body'
              onValueChange={v => onDiscountAmountChange(v.floatValue ?? 0)}
            />
          </div>
        </div>

        <div className='row g-2 mb-2'>
          <div className='col-6'>
            <label className='form-label mb-1'>{t('نسبة ض.ق')}</label>
            <input className='form-control form-control-sm bg-inverse bg-opacity-10' readOnly value={vatRateDisplay} />
          </div>
          <div className='col-6'>
            <label className='form-label mb-1'>{t('قيمة ض.ق')}</label>
            <input className='form-control form-control-sm bg-inverse bg-opacity-10' readOnly value={fmt(vatTotal)} />
          </div>
        </div>

        <div>
          <label className='form-label mb-1 fw-bold'>{t('الصافي')}</label>
          <input className='form-control form-control   fw-bold fs-4 text-theme ' readOnly value={fmt(netTotal)} />
        </div>
      </div>
    </div>
  );








  
};
